import type Activity from '../model/Activity'
import type Gate from '../model/Gate'

export function isActivityUnlocked(
  activity: Activity,
  gates: Gate[],
  teamProgress: number,
): boolean {
  if (!activity.gateId) return true
  const gate = gates.find((candidate) => candidate.id === activity.gateId)
  if (!gate) return false
  return teamProgress >= gate.checkpoint.threshold
}

export function loggableActivities(
  activities: Activity[],
  gates: Gate[],
  teamProgress: number,
): Activity[] {
  return activities.filter((activity) => isActivityUnlocked(activity, gates, teamProgress))
}
